import { MapLayerGroupControl } from '@/views/map/MapLayerManager/MapLayerGroupControl/MapLayerGroupControl';
import { useAppSelector, useAppDispatch } from '@/app/hooks';
import { update as updateMapLayerConfig } from '@/features/mapLayerSlice';
import { LayerType } from '@/views/map/layers/types';
import TagManager from 'react-gtm-module';
import { GoogleEvents } from '@/features/googleEvents';

export const RedFlagWarningControl = () => {
  const dispatch = useAppDispatch();
  const layerConfig = useAppSelector((s) => s.mapLayer);

  const isActive = layerConfig[LayerType.red_flag_warning].visible;

  const toggleRedFlagWarningLayer = (v: boolean) => {
    TagManager.dataLayer({
      dataLayer: {
        event: v ? GoogleEvents.wildfireLayerOn : GoogleEvents.wildfireLayerOff,
      },
    });
    return dispatch(
      updateMapLayerConfig({
        [LayerType.red_flag_warning]: { visible: v },
      })
    );
  };

  return (
    <MapLayerGroupControl
      icon="RedFlagWarning"
      title="Red flag warnings"
      onVisibilityChange={toggleRedFlagWarningLayer}
      isGroupVisible={isActive}
      data-testid="red-flag-warning-control"
    />
  );
};
